module.exports = __webpack_public_path__ + "static/media/apartment1.494bab34.jpg";